var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar-expand-md navbar-dark bg-dark",attrs:{"id":"headerJobs"}},[_c('div',{staticStyle:{"display":"block","margin":"0 auto","text-align":"center"}},[_c('div',[_c('div',[_c('span',{class:[
                            'badge badge-pill badge-light numID desktop',
                            _vm.open ? 'active' : '',
                        ],on:{"click":function($event){return _vm.timesheet()}}},[_c('span',{staticClass:"titulo-cont"},[_vm._v("Timesheet")])]),_c('span',{class:[
                            'badge badge-pill badge-light completed desktop',
                            _vm.completed ? 'active' : '',
                        ],on:{"click":function($event){return _vm.task()}}},[_c('span',{staticClass:"titulo-cont"},[_vm._v("Task")])])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }